import {
  Elements,
  ElementsConsumer,
  PaymentElement,
} from '@stripe/react-stripe-js';
import React, { useEffect, useMemo, useRef } from 'react';
import { createUseStyles } from 'react-jss';
import { layoutDefaults } from '../../utils/layout-defaults';
import { PaymentDetails } from './payment-details';

function NewPaymentCardModalBody({
  payment,
  spot,
  menuInfo,
  feature,
  stripe,
  elements,
  onLoad,
  onError,
  onSuccess,
}) {
  // const elements = useElements();
  // const stripe = useStripe();
  // const [errorMessage, setErrorMessage] = useState(null);
  const formRef = useRef();
  const promiseRef = useRef();
  const promiseResolverRef = useRef();
  const classes = useStyles();

  const charge = async () => {
    promiseRef.current = new Promise((resolve) => {
      promiseResolverRef.current = resolve;
    });

    await formRef.current.requestSubmit();
    await Promise.all([promiseRef.current]);

    console.log('charge charge charge charge charge charge');
  };

  useEffect(() => {
    if (stripe != null && elements != null) {
      // onLoad?.call(this, { stripe, elements });
      onLoad?.call(this, { charge });
    }
  }, [stripe, elements, onLoad]);

  const setError = (error) => {
    onError?.call(this, error);
  };

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    // setError(null);
    event.preventDefault();

    // if (!stripe || !elements) {
    //   // Stripe.js hasn't yet loaded.
    //   // Make sure to disable form submission until Stripe.js has loaded.
    //   return;
    // }

    const result = await stripe.confirmPayment({
      // `Elements` instance that was used to create the Payment Element
      elements,
      redirect: 'if_required',
      confirmParams: {
        return_url: 'https://example.com/order/123/complete',
      },
    });

    if (result.error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (for example, payment
      // details incomplete)

      // result.error.handleGeneric = false;
      setError(result.error);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
      onSuccess.call(this, result);
    }

    promiseResolverRef.current();
  };

  return (
    <div className={classes.container}>
      {/* <FadeIn delay={150}>
        <div className={classes.title}>{t('card-payment.modal.title')}</div>
      </FadeIn>
      <FadeIn delay={200}>
        <PrivacyNotice
          analytics={analytics}
          getPrivacyPolicyFromRemote={getPrivacyPolicyFromRemote}
        />
      </FadeIn> */}
      <form ref={formRef} onSubmit={handleSubmit}>
        <div className={classes.element}>
          <PaymentElement
            onChange={() => setError(null)}
            // i18nIsDynamicList={false}
            options={{
              layout: 'tabs',
              // defaultCollapsed: false,
              readOnly: false,
              // defaultValues: {
              //   card: {
              //     cardNumber: '424242424',
              //     cardExpiry: '12/23',
              //   },
              // },
              wallets: {
                applePay: 'never',
                googlePay: 'never',
              },
            }}
          />
        </div>
        {/* <CardElement
          options={{
            layout: 'tabs',
            wallets: {
              applePay: 'never',
              googlePay: 'never',
            },
          }}
        /> */}

        {/* <Button onClick={}>Enviar</Button> */}
        {/* Show error message to your customers */}
        {/* {errorMessage && <div>{errorMessage}</div>} */}
      </form>

      <PaymentDetails
        style={classes.total}
        payment={payment}
        spot={spot}
        menuInfo={menuInfo}
        feature={feature}
        // stripe={stripe}
        elements={elements}
      />
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    marginTop: -layoutDefaults.smallVerticalMargin,
    // border: '1px solid white',
  },

  element: {
    backgroundColor: layoutDefaults.cardColor,
    paddingTop: layoutDefaults.bigVerticalMargin,
    paddingBottom: layoutDefaults.bigVerticalMargin,
    paddingLeft: layoutDefaults.bigHorizontalMargin,
    paddingRight: layoutDefaults.bigHorizontalMargin,
  },

  total: {
    // marginTop: layoutDefaults.biggerVerticalMargin,
  },

  // title: {
  //   fontSize: layoutDefaults.biggestFontSize,
  //   fontWeight: 'bold',
  //   marginTop: -layoutDefaults.bigVerticalMargin,
  // },

  // '@global': {
  //   '.Label': {
  //     color: 'blue', // Substitua #333 pela cor que você deseja
  //   },
  // },
});

function StripeElementsConsumer(props) {
  return (
    <ElementsConsumer>
      {({ stripe, elements }) => (
        <NewPaymentCardModalBody
          {...props}
          stripe={stripe}
          elements={elements}
        />
      )}
    </ElementsConsumer>
  );
}

function StripeBodyWrapper(props) {
  // const {loadStripeClientIdFromRemote} = useTempAPI();
  const { clientSecret, menuLayout, stripePromise } = props;
  const font = menuLayout?.text?.default_font;

  // useEffect(() => {
  //   console.log('clientSecret');
  //   console.log(clientSecret);
  // }, [clientSecret]);

  // const [clientId, setClientId] = useState();

  // useEffect(() => {
  //   async function init() {
  //     const response = await loadStripeClientIdFromRemote();
  //     setClientId(response.data);
  //   }

  //   init();
  // }, []);

  console.log('layout');
  console.log(menuLayout?.text?.default_font);

  // const stripePromise = useMemo(
  //   () => loadStripe(config?.stripe?.api_key),
  //   [config?.stripe]
  // );

  const appearance = useMemo(
    () => ({
      theme: 'stripe',
      variables: {
        fontSizeBase: layoutDefaults.smallFontSize,
        // fontWeightNormal: 100,
        // colorText: layoutDefaults.textPlaceholderColor,
        // colorTextSecondary: layoutDefaults.textPlaceholderColor,
        // colorTextSecondary: 'red',
        // colorPrimaryText: layoutDefaults.primaryColor,
        // colorPrimaryText: 'red',
        // colorTextSecondary: 'red',
        // colorPrimaryText: 'red',
        colorText: layoutDefaults.primaryColor,
        // colorText: layoutDefaults.buttonBorder,
        colorTextPlaceholder: layoutDefaults.buttonBorder,
        colorDanger: layoutDefaults.destructiveColor,
        fontFamily: menuLayout?.text?.default_font,
        // fontWeight: 100,
      },
    }),
    [menuLayout]
  );

  const options = useMemo(
    () => ({
      loader: 'always',
      clientSecret,
      fonts: [
        {
          cssSrc: `https://fonts.googleapis.com/css?family=${font}:200,400,500,600`,
        },
      ],
      appearance,
    }),
    [appearance, clientSecret]
  );

  if (!clientSecret) {
    return null;
  }

  return (
    <Elements stripe={stripePromise} options={options}>
      <StripeElementsConsumer {...props} />
    </Elements>
  );
}

export { StripeBodyWrapper as NewPaymentCardModalBody };
